import React from 'react';
import { validateEmail, validatePhoneNumber } from 'allianz-library';

import ContactNotice from './ContactNotice';
import { LabelEt, InputWithoutRequiredIndicator } from './styledComponents';

const validatorEmail = (val) => validateEmail(val,'Merci de respecter le format mail@exemple.com');
const validatorPhone = (val) => validatePhoneNumber(val,'Le numéro doit contenir 10 chiffres');

const ContactInformations = () => (
  <>
    <InputWithoutRequiredIndicator name="email" label="Email*" type="email" validation={validatorEmail} required />
    <LabelEt></LabelEt>
    <InputWithoutRequiredIndicator
      name="phoneNumber"
      label="Téléphone*"
      type="tel"
      validation={validatorPhone}
      required
    />
    <ContactNotice />
  </>
);

export default ContactInformations;